import React from 'react';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import './UserInfo.css';

export default function UserInfo({ user }) {
  return (
    <div className="user-info-card">
      <div className="user-avatar">
        <PersonRoundedIcon className="avatar-icon" />
      </div>
      <div className="user-details">
        <h2>{user.name}</h2>
        <div className="info-item">
          <MailOutlineRoundedIcon className="info-icon" />
          <span>{user.email}</span>
        </div>
      </div>
    </div>
  );
} 